// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1TdLt","consentsList":"PatientConsents_consentsList__2894i","consentsListEmpty":"PatientConsents_consentsListEmpty__2fg7j"};